import * as React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormCheckbox } from '@enginuity-apps-ui-components/molecules/form-elements/form-checkbox/form-checkbox';
import EditableFormSection from '../../../../../ui-components/library/apps/organisms/editable-section/editable-form-section';
import { IUserProfileFormData } from '@enginuity-common/types/user';
import { ISubmitStatus } from '../../pages/account/manage-account';
import { useEffect } from 'react';

export type IManageAccountOptInsProps = {
  onSubmit: (data: IUserProfileFormData) => Promise<ISubmitStatus>;
  data?: IUserProfileFormData;
  intialEditMode?: boolean;
};

export default function ManageAccountOptIns({ onSubmit, data, intialEditMode }: IManageAccountOptInsProps) {
  const { register, handleSubmit, errors } = useForm();
  const [editMode, setEditMode] = useState<boolean>(!!intialEditMode)
  const [submitError, setSubmitError] = useState<JSX.Element | undefined>();
  const [formData, setFormData] = useState<IUserProfileFormData | undefined>(data);

  const saveForm = (submitData: IUserProfileFormData) => {
    onSubmit(submitData)
      .then((submitStatus: ISubmitStatus) => {
        if (submitStatus.result) {
          setEditMode(false);
        }
        else {
          setSubmitError(submitStatus.error);
        }
      })
  }

  const resetData = (mode: boolean) => {
    setFormData(data && { ...data }); //revert to original data
    setEditMode(mode);
  }

  useEffect(() => {
    setFormData(data);
  }, [data]);


  return (
    <EditableFormSection
      sectionTitle="02. Opt ins"
      onSubmit={handleSubmit(saveForm)}
      submitError={submitError}
      errors={errors}
      editMode={editMode}
      onEditModeChange={(mode: boolean) => resetData(mode)}
    >
      <div className="row md-spacer-32 spacer-16">
        <div className="col-lg-12">
          <p className={`marketing-label ${editMode ? "" : "read-only"}`}>Marketing and future communication:</p>
        </div>
      </div>
      <div className="row spacer-16">
        <div className="col-lg-12">
          <FormCheckbox
            label={<div>
              <p>Get personalised emails based on your Engage interests and activity.<br /><br /></p>
              <p>We treat your data with the utmost care, and you can unsubscribe at any time.<br /><br /></p>
              <p>“We” includes Enginuity Group, its subsidiaries (Enginuity, Enginuity Enterprise, EAL), and technology partners (Filtered). <br /><br /></p>
              <p>For further details on how your data is used and stored: <a href="https://enginuity.org/privacy/" target="_blank">https://enginuity.org/privacy/</a></p>
            </div>}
            id="keepMeInformed"
            defaultChecked={formData && formData.keepMeInformed}
            ref={register()}
            errors={errors}
            showReadOnly={!editMode}
          />
        </div>
      </div>
    </EditableFormSection>
  );
}
